import React, { useContext, useEffect, useMemo, useState } from 'react';
import ReactTable from '../../components/ReactTable/ReactTable.jsx';
import { Link } from 'react-router-dom';
import { FaEye } from "react-icons/fa";
import { config } from '../../config.js';
import { SidebarContext } from '../../context/SidebarContext';
import SectionMenuLeft from '../../components/SectionMenuLeft/SectionMenuLeft.jsx';
function Rating() {
	const [ratings, setRatings] = useState([]);
	const [filteredRatings, setFilteredRatings] = useState([]);
	const [loading, setLoading] = useState(true);
	const { isSidebar } = useContext(SidebarContext);

	const getRatings = async () => {
		setLoading(true);
		try {
			const response = await fetch(`${config?.backEndBaseUrl}user/get`, {
				method: 'GET',
				headers: {
					'Content-Type': 'application/json',
					'x-dashboard-request': 'true'
				}
			});


			if (!response.ok) {
				throw new Error(`HTTP error! Status: ${response.status}`);
			}

			const result = await response.json();
			if (result.status && Array.isArray(result.users)) {
				setRatings(result.users);
				setFilteredRatings(result.users);
			} else {
				setRatings([]);
				setFilteredRatings([]);
			}
		} catch (error) {
			console.error('Fetching users failed:', error);
			setRatings([]);
			setFilteredRatings([]);
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		getRatings();
	}, []);

	const columns = useMemo(
		() => [
			{ accessorKey: 'userName', header: 'Name' },
			{
				accessorKey: 'photoURL',
				header: 'Photo',
				cell: ({ row }) => {
					<a href={row.original.photoURL} target="_blank" rel="noopener noreferrer">
						<img
							src={row.original.photoURL}
							alt={row.original.userName}
							style={{
								width: 80,
								height: 80,
								borderRadius: 10,
								border: '1px solid gray',
								objectFit: 'contain',
								background: 'lightGray',
								cursor: 'pointer'
							}}
						/>
					</a>

				}
			},
			{ accessorKey: 'phoneNumber', header: 'Number' },
			{ accessorKey: 'email', header: 'Email' },

		],
		[]
	);



	return (
		<div className="body">
			<div id="wrapper">
				<div id="page" className="">
					<div className="layout-wrap">
						<SectionMenuLeft />
						<div className="section-content-right">
							<div className="main-content" style={{ paddingLeft: isSidebar ? '280px' : '0px' }}>
								<div className="main-content-inner">
									<div className="main-content-wrap">
										<div className="tf-section">
											<div className="wg-box" style={{ marginBottom: '20px' }}>
												<div className="flex items-center justify-between">
													<h5>Ratings Overview</h5>
												</div>

												{/* Show spinner while loading */}
												{loading ? (
													<div className="loading-spinner" style={{ textAlign: 'center', padding: '20px' }}>
														<div className="spinner-border text-primary" role="status">
															<span className="sr-only">Loading...</span>
														</div>
													</div>
												) : (
													<>
														<ReactTable columns={columns} data={filteredRatings} />
													</>
												)}
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>


	);
}

export default Rating;



